import axios from 'axios';

interface LoginInput {
  username: string;
  password: string;
}

interface User {
  id: string;
  username: string;
  role: string;
  permissions: string[];
}

interface AuthTokens {
  accessToken: string;
  refreshToken?: string;
  expiresIn?: number;
  user?: User;
}

// Update API URL
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';  // Changed port to 3000

// Add detailed logging for environment variables
console.log('=== AUTH SERVICE INITIALIZATION ===');
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('All REACT_APP environment variables:', {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_HASURA_ENDPOINT: process.env.REACT_APP_HASURA_ENDPOINT,
  REACT_APP_NESTJS_GRAPHQL_ENDPOINT: process.env.REACT_APP_NESTJS_GRAPHQL_ENDPOINT,
});
console.log('Final API_URL being used:', API_URL);
console.log('Current window.location:', window.location);
console.log('==========================================');

export const authService = {
  // Remove validateToken method
  login: async (username: string, password: string): Promise<AuthTokens> => {
    console.log('Auth service: attempting login with username:', username);
    
    try {
      const response = await axios.post(
        `${API_URL}/api/v1/admin/auth/login`,
        { username, password },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      
      const { accessToken } = response.data.data;
      localStorage.setItem('token', accessToken);
      
      return { accessToken };
    } catch (error: any) {
      console.error('Auth service: login error:', error);
      throw new Error(error.response?.data?.message || 'Ошибка аутентификации');
    }
  },

  logout: () => {
    localStorage.removeItem('token');
  },

  setupAxios: () => {
    axios.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
  }
}; 